import { render } from "./OrdersInformation.vue?vue&type=template&id=421f4e8e&scoped=true"
import script from "./OrdersInformation.vue?vue&type=script&lang=js"
export * from "./OrdersInformation.vue?vue&type=script&lang=js"

import "./OrdersInformation.vue?vue&type=style&index=0&id=421f4e8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-421f4e8e"]])

export default __exports__